'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var getFont = functions.config.fonts.getFont;
var colors = functions.config.colors.list;
var sizesTitle = {
  titleXxxs: '1.4rem',
  titleXxs: '1.6rem',
  titleXs: '1.8rem',
  titleSm: '2rem',
  titleMd: '2.4rem',
  titleLg: '3.0rem',
  titleXl: '3.6rem',
  titleXxl: '5.0rem',
  titleXxxl: '6.4rem'
};
var sizesSecure = _objectSpread2(_objectSpread2({}, sizesTitle), {}, {
  bodySm: '1.2rem',
  bodyMd: '1.4rem',
  bodyLg: '1.6rem'
});
var sizesPublic = _objectSpread2(_objectSpread2({}, sizesTitle), {}, {
  bodySm: '1.6rem',
  bodyMd: '1.8rem',
  bodyLg: '1.8rem'
});
var StyledSpan = styled.span.withConfig({
  displayName: "Span__StyledSpan",
  componentId: "sc-4gov5k-0"
})(["font-family:", ";font-size:", ";color:", ";"], function (props) {
  return props.weight ? getFont(props.theme, props.weight) : 'inherit';
}, function (props) {
  if (!props.size) return 'inherit';
  return props.theme && props.theme.type === 'public' ? sizesPublic[props.size] : sizesSecure[props.size];
}, function (props) {
  return props.color ? colors[props.color] : 'inherit';
});
var Span = function Span(props) {
  return /*#__PURE__*/React.createElement(StyledSpan, {
    size: props.size,
    weight: props.weight,
    color: props.color,
    className: props.className
  }, props.children);
};
exports.Span = Span;